// extracted by mini-css-extract-plugin
export default {"button":"xq","primary":"yq","fullWidth":"zq","secondary":"Aq","nutrition":"Bq","underlined":"Cq","small":"Eq","medium":"Fq","info":"Gq","white":"Hq","border":"Iq","mango":"Jq","charcoal":"Kq","court":"Lq","green":"Mq","spark":"Nq","linkButton":"Oq","disabled":"Pq"};
    if(module.hot) {
      // 1713809675622
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  